export const tempMovieData = [
  {
    imdbID: "tt1375666",
    Title: "Inception",
    Year: "2010",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg",
  },
  {
    imdbID: "tt0133093",
    Title: "The Matrix",
    Year: "1999",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    imdbID: "tt6751668",
    Title: "Parasite",
    Year: "2019",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BYWZjMjk3ZTItODQ2ZC00NTY5LWE0ZDYtZTI3MjcwN2Q5NTVkXkEyXkFqcGdeQXVyODk4OTc3MTY@._V1_SX300.jpg",
  },
];

export const DataMyLists = [
  {
    _id: 10001,
    title: "Selfless love",
    audience: "public",
    createdAt: "2025-10-05T19:00:00Z",

    mubis: [
      {
        id: "tt0118694",
        title: "In the Mood for Love",
        year: 2000,
        genre: ["Drama", "Romance"],
        durationMinutes: 98,
        director: "Wong Kar-wai",
        cast: [
          "Tony Leung Chiu-wai",
          "Maggie Cheung",
          "Rebecca Pan",
          "Kelly Lai Chen",
        ],
        rating: 8.1,
        votes: 170000,
        language: "Cantonese, Shanghainese, French",
        country: "Hong Kong, France",
        plot: "Two neighbors form a strong bond after both suspect their spouses of infidelity. However, they agree to keep their relationship platonic to avoid falling into the same patterns.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiCL1dmT4swBQuIfzthOZh_ne2sFFzAfLoTyu8r3ZrU3WJ8RtjZcqfrns&s=10",
      },
      {
        id: "tt0133093",
        title: "The Matrix",
        year: 1999,
        genre: ["Action", "Sci-Fi"],
        durationMinutes: 136,
        director: "Lana Wachowski, Lilly Wachowski",
        cast: [
          "Keanu Reeves",
          "Laurence Fishburne",
          "Carrie-Anne Moss",
          "Hugo Weaving",
        ],
        rating: 8.7,
        votes: 2000000,
        language: "English",
        country: "USA",
        plot: "A computer hacker learns about the true nature of reality and his role in the war against its controllers.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTX1s1SiveaHQHn1x1BdHKceVrflm-l35aSmP9Vzcl40w&s=10",
      },
      {
        id: "tt0468569",
        title: "The Dark Knight",
        year: 2008,
        genre: ["Action", "Crime", "Drama"],
        durationMinutes: 152,
        director: "Christopher Nolan",
        cast: [
          "Christian Bale",
          "Heath Ledger",
          "Aaron Eckhart",
          "Maggie Gyllenhaal",
        ],
        rating: 9.0,
        votes: 2800000,
        language: "English",
        country: "USA",
        plot: "Batman faces the Joker, a criminal mastermind who plunges Gotham City into chaos.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-ZnqwQwjLGxD6fbEJHXbqOaqSSY7HE9fKtgOhL0elOg&s=10",
      },
      {
        id: "tt0109830",
        title: "Forrest Gump",
        year: 1994,
        genre: ["Drama", "Romance"],
        durationMinutes: 142,
        director: "Robert Zemeckis",
        cast: ["Tom Hanks", "Robin Wright", "Gary Sinise", "Sally Field"],
        rating: 8.8,
        votes: 2200000,
        language: "English",
        country: "USA",
        plot: "The life journey of a man with a kind heart but limited intelligence, witnessing key moments in U.S. history.",
        posterUrl:
          "https://i.pinimg.com/736x/7e/08/33/7e08336b2ada933ec036f2c2362efd7e.jpg",
      },
      {
        id: "tt0111161",
        title: "The Shawshank Redemption",
        year: 1994,
        genre: ["Drama"],
        durationMinutes: 142,
        director: "Frank Darabont",
        cast: ["Tim Robbins", "Morgan Freeman", "Bob Gunton", "William Sadler"],
        rating: 9.3,
        votes: 2800000,
        language: "English",
        country: "USA",
        plot: "Two imprisoned men bond over years, finding solace and eventual redemption through acts of common decency.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdCECysUYi0v8v-mkrkieyQD7Bym7QWdpFYnaTpbP9NQvnuGWvRQcJBfIE&s=10",
      },
      {
        id: "tt0111163",
        title: "How to dissapear",
        year: 1994,
        genre: ["Drama"],
        durationMinutes: 142,
        director: "Frank Darabont",
        cast: ["Tim Robbins", "Morgan Freeman", "Bob Gunton", "William Sadler"],
        rating: 9.3,
        votes: 2800000,
        language: "English",
        country: "USA",
        plot: "Two imprisoned men bond over years, finding solace and eventual redemption through acts of common decency.",
        posterUrl:
          "https://upload.wikimedia.org/wikipedia/en/d/df/Arrival%2C_Movie_Poster.jpg",
      },
      {
        id: "tt1851428",
        title: "Alice in the wonderland",
        year: 2012,
        genre: ["Drama", "Western"],
        durationMinutes: 165,
        director: "Quentin Tarantino",
        cast: [
          "Jamie Foxx",
          "Christoph Waltz",
          "Leonardo DiCaprio",
          "Kerry Washington",
        ],
        rating: 8.4,
        votes: 1600000,
        language: "English",
        country: "USA",
        plot: "With the help of a German bounty hunter, a freed slave sets out to rescue his wife from a brutal plantation owner.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxq9V8h85pD0vmAR6dR_t7h9QTxlHWu-6XyUSZVMwRdw&s=10",
      },
    ],

    description:
      "Esta lista la hice de las películas que veía cuando te perdí, aunque en realidad nunca te tuve, me he sentado a reflexionar cuando extraño algo que nunca se dio, no paro de llorar en mis sueños, despiero en medio de las lagrimas de aquel sueño que parece sacado de una realidad alterna, al que me desisto a creer, pero al final de la noche despierto sabiendo que nada es real, que la unica verdad absoluta es que pedí a la vida algo que me dolía, que realmente nunca debí irme, nunca debimos irnos, ahora solo queda en irnos",
  },

  {
    _id: 10002,
    title: "Moments of Courage",
    audience: "friends",
    createdAt: "2024-08-01T19:00:00Z",
    mubis: [
      {
        id: "tt1375666",
        title: "Inception",
        year: 2010,
        genre: ["Action", "Sci-Fi", "Thriller"],
        durationMinutes: 148,
        director: "Christopher Nolan",
        cast: [
          "Leonardo DiCaprio",
          "Joseph Gordon-Levitt",
          "Ellen Page",
          "Tom Hardy",
        ],
        rating: 8.8,
        votes: 2300000,
        language: "English",
        country: "USA",
        plot: "A skilled thief is given a chance at redemption if he can successfully perform inception: planting an idea inside a target's subconscious.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOzRigSbUcjA4IV9CnQP0N1rlUwkooKhs1FA6_5ZaAOQ&s=10",
      },
      {
        id: "tt0167260",
        title: "The Lord of the Rings: The Return of the King",
        year: 2003,
        genre: ["Adventure", "Drama", "Fantasy"],
        durationMinutes: 201,
        director: "Peter Jackson",
        cast: [
          "Elijah Wood",
          "Viggo Mortensen",
          "Ian McKellen",
          "Orlando Bloom",
        ],
        rating: 9.0,
        votes: 1900000,
        language: "English",
        country: "New Zealand, USA",
        plot: "The final confrontation between the forces of good and evil fighting for the fate of Middle-earth.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOxoQ19qHMfhmBMRk1Sbt0aqsd7pzUCwzbcKyzTT32mQ&s=10",
      },
      {
        id: "tt0120737",
        title: "The Lord of the Rings: The Fellowship of the Ring",
        year: 2001,
        genre: ["Adventure", "Drama", "Fantasy"],
        durationMinutes: 178,
        director: "Peter Jackson",
        cast: ["Elijah Wood", "Ian McKellen", "Orlando Bloom", "Sean Astin"],
        rating: 8.8,
        votes: 1900000,
        language: "English",
        country: "New Zealand, USA",
        plot: "A hobbit embarks on a perilous journey with his companions to destroy a powerful ring.",
        posterUrl: "https://m.media-amazon.com/images/I/51Qvs9i5a%2BL._AC_.jpg",
      },
      {
        id: "tt1853728",
        title: "Django Unchained",
        year: 2012,
        genre: ["Drama", "Western"],
        durationMinutes: 165,
        director: "Quentin Tarantino",
        cast: [
          "Jamie Foxx",
          "Christoph Waltz",
          "Leonardo DiCaprio",
          "Kerry Washington",
        ],
        rating: 8.4,
        votes: 1600000,
        language: "English",
        country: "USA",
        plot: "With the help of a German bounty hunter, a freed slave sets out to rescue his wife from a brutal plantation owner.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSP4lzna2_wTsxCh6xa8Sn0pPcsxMfh8CnYV7KSyBcYmKcsr4dZvTjaIoM&s=10",
      },
      {
        id: "tt1851428",
        title: "Alice in the wonderland",
        year: 2012,
        genre: ["Drama", "Western"],
        durationMinutes: 165,
        director: "Quentin Tarantino",
        cast: [
          "Jamie Foxx",
          "Christoph Waltz",
          "Leonardo DiCaprio",
          "Kerry Washington",
        ],
        rating: 8.4,
        votes: 1600000,
        language: "English",
        country: "USA",
        plot: "With the help of a German bounty hunter, a freed slave sets out to rescue his wife from a brutal plantation owner.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxq9V8h85pD0vmAR6dR_t7h9QTxlHWu-6XyUSZVMwRdw&s=10",
      },
      {
        id: "tt1801428",
        title: "Life of Pi",
        year: 2012,
        genre: ["Drama", "Western"],
        durationMinutes: 165,
        director: "Quentin Tarantino",
        cast: [
          "Jamie Foxx",
          "Christoph Waltz",
          "Leonardo DiCaprio",
          "Kerry Washington",
        ],
        rating: 8.4,
        votes: 1600000,
        language: "English",
        country: "USA",
        plot: "With the help of a German bounty hunter, a freed slave sets out to rescue his wife from a brutal plantation owner.",
        posterUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0CDe5xp_sOGQPaRl6BONDEuzl4LtjoUhf0w&s",
      },
    ],

    description:
      "Esta lista la armé pensando en el valor de ser valiente: son historias que me han inspirado a seguir adelante en momentos de duda.",
  },
];

export const DataNotesRelatedLists = [
  {
    list: 10002,
    id_mubi: "tt1851428",
    id_item: 1,
    note: "No hay nada de malo en querer amor. Es una necesidad humana básica: todos queremos sentir que alguien nos elige, nos ve y nos valora.El punto donde se vuelve riesgoso es cuando ese deseo se vuelve inconsciente y dirige tus decisiones, haciéndote quedarte en relaciones que te dan migajas solo porque “algo bueno debe haber en ellos, esta pertenece al 2",
  },
  {
    list: 10002,
    id_mubi: "tt0120737",
    id_item: 2,
    note: "Eso que acabas de decir, Ross, es una de las reflexiones más profundas y honestas que se pueden tener. 🌿Lo que describes —ese deseo inconsciente de sentirte amada y la tendencia a ver lo mejor en los demás— no es una debilidad; es una herida emocional envuelta en bondad. Tiene mucho valor reconocerlo, porque ahí es donde empieza el cambio real.",
  },
  {
    list: 10002,
    id_mubi: "tt1853728",
    id_item: 3,
    note: "Ross, eso que sientes es completamente válido y muy humano: los gestos simbólicos, como las flores, tienen un poder emocional enorme porque no se trata del objeto en sí, sino del significado detrás: alguien pensó en ti, te quiere sorprender o expresarte cariño.",
  },
  {
    list: 10002,
    id_mubi: "tt0167260",
    id_item: 4,
    note: "Lo importante es mantener equilibrio emocional: disfrutar de ese gesto cuando llega, sin que su ausencia te haga sentir menos querida o que la relación no vale. Puedes verlo como un extra bonito, no como un requisito.",
  },
  {
    list: 10001,
    id_mubi: "tt0118694",
    id_item: 5,
    note: "creo que me hará llorar, aún no tengo una idea de lo que se trata la película",
  },

  {
    list: 10001,
    id_mubi: "tt1851428",
    id_item: 6,
    note: "esta pertenece al 1",
  },
  {
    list: 10005,
    id_mubi: "tt0118694",
    id_item: 7,
    note: "Esto me hará llorar",
  },
  {
    list: 10005,
    id_mubi: "tt0133093",
    id_item: 8,
    note: "Matrixxx recargado si señores",
  },
];

export const users = [
  {
    idUser: "usr_001",
    password: "poderLun4r14$$",
    username: "bornsrss",
    givenName: "Emma",
    familyName: "Watson",
    email: "contacto@watson.dev",
    bioDescription: "",
    location: "Córdoba, Ver",
    website: "portafolio.rosfuentes.dev",
    biography:
      "Front-End developer with a background in Software Engineering and a user-centered mindset. I build clean, responsive, and functional web solutions using modern technologies like JavaScript, React, and Taildwind CSS, I work with precision, purpose and character — ready to bring real value to any development team.",
    pronoun: "her",
    profilePicUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSiBzbuoRXqXqixKnB5vRM2M5QNA-aNXwYGFy-tI0x-FIecdIniU5240RIV5-6PPw3tSw&usqp=CAU",
    joinDate: "2024-10-06",
    isVerified: false,
    isPrivate: false,
    /* Estadísticas del usuari  */
    stats: {
      totalFilms: 0,
      totalReviews: 0,
      totalLists: 0,
      totalDiaryEntries: 0,
      followers: 0,
      following: 0,
    },
    /* Aditional social media */
    socialLinks: {
      twitter: undefined,
      instagram: "bornsrss",
      pinterest: "bornsrss14",
    },
    /* Películas Favoritas ♥. aquí la idea es tener un array de ID, referencias a las películas reales  */
    favoriteFourMubis: [
      "tt0118694",
      "tt0876563",
      "tt0181875",
      "tt6751695",
    ] /*In the mood for love, almost famous, ponyo*/,

    /*Listas seguidas  */
    followingLists: [],
    /* Usuarios seguidos/ seguidores */
    following: ["usr_005"],
    followers: ["usr_003", "usr_002", "usr_004"],
    blocked: [],

    favorites: [
      "tt2401878",
      "tt1375666",
      "tt0169858",
      "tt0119698",
      "tt2576852",
      "tt4016934",
      "tt0118694",
      "tt0876563",
    ],
    watchLater: ["tt0073486"],
  },

  {
    idUser: "usr_002",
    password: "pandasAr3Cut3",
    username: "vaneebuga",
    givenName: "Rosario",
    familyName: "Fuentes",
    email: "rosafuentes@gmail.com",
    bioDescription: "",
    location: "Zapopan, Jalisco",
    website: "contacto@desenlacestudio.com/",
    biography:
      "Industrial Engineer ITESM (Instituto Tecnológico y de Estudios Superiores de Monterrey)",
    pronoun: "her",
    profilePicUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3PxU_RqoB6hZj2TBoFiz_nWYOTjQCCPrCvw&s",
    joinDate: "2025-08-16",
    isVerified: false,
    isPrivate: false,
    /* Estadísticas del usuari  */
    stats: {
      totalFilms: 0,
      totalReviews: 0,
      totalLists: 0,
      totalDiaryEntries: 0,
      followers: 0,
      following: 0,
    },
    /* Aditional social media */
    socialLinks: {
      twitter: "vaneebuga",
      instagram: "vaneebuga",
      pinterest: null,
    },
    /* Películas Favoritas ♥. aquí la idea es tener un array de ID, referencias a las películas reales  */
    favoriteFourMubis: ["tt0167261", "tt0137523"],

    /*Listas seguidas  */
    followingLists: [],
    /* Usuarios seguidos/ seguidores */
    following: [],
    followers: ["usr_001"],
    blocked: [],
    favorites: [],
    watchLater: [],
  },
  {
    idUser: "usr_003",
    password: "1234",
    username: "florensspug",
    givenName: "Florence",
    familyName: "Pug",
    email: "florenceandthe@gmail.com",
    bioDescription: "",
    location: "London, England",
    website: "https://www.ballet.org.uk/",
    biography:
      "Leading roles include Clara (role originated on) and Sugar Plum Fairy in Watkin and Smith’s Nutcracker; the title role in Khan’s Giselle and Skeaping’s Giselle; Clara/Sugar Plum in Eagling’s Nutcracker; ",
    pronoun: "her",
    profilePicUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2Dv93ynQPza3aFXHWdah3Fh_cORXhEQjoGw55EIC6dLIglvFSuCC-VQXeJK_Q5FymnaA&usqp=CAU",
    joinDate: "2023-11-14",
    isVerified: false,
    isPrivate: false,
    /* Estadísticas del usuari  */
    stats: {
      totalFilms: 0,
      totalReviews: 0,
      totalLists: 0,
      totalDiaryEntries: 0,
      followers: 0,
      following: 0,
    },
    /* Aditional social media */
    socialLinks: {
      twitter: "vaneebuga",
      instagram: "vaneebuga",
      pinterest: undefined,
    },
    /* Películas Favoritas ♥. aquí la idea es tener un array de ID, referencias a las películas reales  */
    favoriteFourMubis: ["tt0111161", "tt0068646", "tt0468569"],

    /*Listas seguidas  */
    followingLists: [],
    /* Usuarios seguidos/ seguidores */
    following: ["usr_001"] /*Solo me sigue a mi */,
    followers: ["usr_001"],
    blocked: [],
    favorites: [],
    watchLater: [],
  },

  {
    idUser: "usr_004",
    password: "ellefan2024",
    username: "ellefanning",
    givenName: "Elle",
    familyName: "Fanning",
    email: "ellefanning@gmail.com",
    bioDescription: "Actor, dreamer, lover of cinema and storytelling.",
    location: "Los Angeles, California",
    website: "https://www.imdb.com/name/nm1102577",
    biography:
      "Passionate about films that move the soul. Always exploring new stories on screen and behind the scenes.",
    pronoun: "she",
    profilePicUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOaLa9saeNyN6hC-rhX1lFUqsOP2htI8Jzxw&s",
    joinDate: "2024-03-22",
    isVerified: true,
    isPrivate: false,
    /* Estadísticas del usuario */
    stats: {
      totalFilms: 342,
      totalReviews: 87,
      totalLists: 12,
      totalDiaryEntries: 156,
      followers: 8234,
      following: 145,
    },
    /* Additional social media */
    socialLinks: {
      twitter: "ellefanning",
      instagram: "ellefanning",
      pinterest: "ellefanning",
    },
    /* Películas Favoritas ♥ */
    favoriteFourMubis: ["tt0080684"],
    /* Listas seguidas */
    followingLists: [],
    /* Usuarios seguidos/seguidores */
    following: ["usr_001", "usr_005"],
    followers: ["usr_001", "usr_002", "usr_005"],
    blocked: ["usr_003"],
    favorites: [],
    watchLater: [],
  },
  {
    idUser: "usr_005",
    password: "olivia123",
    username: "olivicoook",
    givenName: "Olivia",
    familyName: "Cooke",
    email: "contacto_olivi@gmail.com",
    bioDescription:
      "Actor, dreamer, mother of dragons, oh! no, just joking about my future granny.",
    location: "L.A. Ca.",
    website: "https://www.imdb.com/name/nm1102577",
    biography:
      "Actor, dreamer, mother of dragons, oh! no, just joking about my future granny.",
    pronoun: "she",
    profilePicUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJo8tdCOS0Rh36kGgQeTmKGtL2kFkdzIknUw&s",
    joinDate: "2024-06-14",
    isVerified: true,
    isPrivate: false,
    /* Estadísticas del usuario */
    stats: {
      totalFilms: 342,
      totalReviews: 87,
      totalLists: 12,
      totalDiaryEntries: 156,
      followers: 8234,
      following: 145,
    },
    /* Additional social media */
    socialLinks: {
      twitter: "olivicoooke",
      instagram: "olivicooke",
      pinterest: undefined,
    },
    /* Películas Favoritas ♥ */
    favoriteFourMubis: ["tt2401878", "tt0876563"],
    /* Listas seguidas */
    followingLists: [],
    /* Usuarios seguidos/seguidores */
    following: ["usr_001", "usr_003"],
    followers: ["usr_001", "usr_003"],
    blocked: [],
    favorites: [],
    watchLater: [],
  },
];

export const DataBaseWatchLater = [
  {
    id: 30301,
    idMubiWatch: "tt0073486",
    idUserAsociated: "usr_001",
  },
  {
    id: 30302,
    idMubiWatch: "tt1375666",
    idUserAsociated: "usr_001",
  },
];

export const DataBaseWatched = [
  {
    id: 40401,
    idMubiWatched: "tt0111771",
    idUserAsociated: "usr_001",
  },
];

export const temDataMubisTotal = [
  {
    id: "tt2401878",
    title: "Anomalisa",
    year: 2015,
    genre: ["Animation", "Drama", "Romance"],
    durationMinutes: 90,
    director: "Charlie Kaufman, Duke Johnson",
    cast: ["David Thewlis", "Jennifer Jason Leigh", "Tom Noonan"],
    rating: 7.7,
    votes: 130000,
    language: "English",
    country: "United States",
    plot: "A lonely motivational speaker, crippled by the mundanity of his life, meets a uniquely ordinary woman who might be the cure for his isolation—if only he can truly see her as she is.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRO3vXS5tf1oDDpq3O46x5KAYlAFbrkINu_LQ&s",
  },
  {
    id: "tt1375666",
    title: "Inception",
    year: 2010,
    genre: ["Action", "Sci-Fi", "Thriller"],
    durationMinutes: 148,
    director: "Christopher Nolan",
    cast: [
      "Leonardo DiCaprio",
      "Joseph Gordon-Levitt",
      "Ellen Page",
      "Tom Hardy",
    ],
    rating: 8.8,
    votes: 2300000,
    language: "English",
    country: "USA",
    plot: "A skilled thief is given a chance at redemption if he can successfully perform inception: planting an idea inside a target's subconscious.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOzRigSbUcjA4IV9CnQP0N1rlUwkooKhs1FA6_5ZaAOQ&s=10",
  },
  {
    id: "tt0169858",
    title: "The End of Evangelion",
    year: 1997,
    genre: ["Animation", "Action", "Drama", "Sci-Fi", "Psychological"],
    durationMinutes: 87,
    director: "Hideaki Anno, Kazuya Tsurumaki",
    cast: [
      "Megumi Ogata",
      "Megumi Hayashibara",
      "Yuko Miyamura",
      "Kotono Mitsuishi",
      "Akira Ishida",
      "Fumihiko Tachiki",
    ],
    rating: 8.5,
    votes: 105000,
    language: "Japanese",
    country: "Japan",
    plot: "As the Human Instrumentality Project begins, Shinji Ikari faces the collapse of reality and the consequences of his choices, as the world descends into chaos and humanity nears its end.",
    posterUrl:
      "https://images.squarespace-cdn.com/content/v1/5e7a8f6d95bc3643e73bc2e8/1650516930473-W9V90ZE5IMW5MOAT4F51/EVA_POSTER_5400x7200.jpg?format=2500w",
  },
  {
    id: "tt0119698",
    title: "Princess Mononoke",
    year: 1997,
    genre: ["Animation", "Action", "Adventure", "Fantasy"],
    durationMinutes: 134,
    director: "Hayao Miyazaki",
    cast: [
      "Yoji Matsuda",
      "Yuriko Ishida",
      "Yuko Tanaka",
      "Kaoru Kobayashi",
      "Masahiko Nishimura",
      "Tetsu Watanabe",
    ],
    rating: 8.4,
    votes: 450000,
    language: "Japanese",
    country: "Japan",
    plot: "On a journey to find a cure for a curse, a young warrior named Ashitaka becomes entangled in a battle between forest gods and humans who consume its resources. In the midst of the conflict, he meets the mysterious Princess Mononoke.",
    posterUrl:
      "https://www.tallengestore.com/cdn/shop/products/PrincessMononoke-StudioGhibliJapanaeseAnimatedMoviePoster_7ffbd668-7bf0-4a03-9934-da7d1fa2ffed.jpg?v=1642160523",
  },
  {
    id: "tt2576852",
    title: "The Tale of the Princess Kaguya",
    year: 2013,
    genre: ["Animation", "Drama", "Fantasy"],
    durationMinutes: 137,
    director: "Isao Takahata",
    cast: [
      "Aki Asakura",
      "Kengo Kora",
      "Takeo Chii",
      "Nobuko Miyamoto",
      "Atsuko Takahata",
      "Tomoko Tabata",
    ],
    rating: 8.0,
    votes: 97000,
    language: "Japanese",
    country: "Japan",
    plot: "Found inside a shining bamboo stalk, a tiny girl grows rapidly into an exquisite young woman. As she attracts suitors from across the land, she struggles with the constraints of her royal life and the pull of her mysterious origins.",
    posterUrl:
      "https://i.pinimg.com/564x/48/bd/0d/48bd0d791162ee722890842ac1023352.jpg",
  },
  {
    id: "tt4016934",
    title: "The Handmaiden",
    year: 2016,
    genre: ["Drama", "Romance", "Thriller"],
    durationMinutes: 145,
    director: "Park Chan-wook",
    cast: [
      "Kim Min-hee",
      "Kim Tae-ri",
      "Ha Jung-woo",
      "Cho Jin-woong",
      "Moon So-ri",
    ],
    rating: 8.1,
    votes: 170000,
    language: "Korean, Japanese",
    country: "South Korea",
    plot: "In 1930s Korea, during the Japanese occupation, a young woman is hired as a handmaiden to a Japanese heiress. However, she is secretly involved in a plot to defraud her — until unexpected emotions complicate their plan.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCbaWHc1UHI-PZtMgTyOMxyd2NqBHWpVRa1A&s",
  },
  {
    id: "tt0118694",
    title: "In the Mood for Love",
    year: 2000,
    genre: ["Drama", "Romance"],
    durationMinutes: 98,
    director: "Wong Kar-wai",
    cast: [
      "Tony Leung Chiu-wai",
      "Maggie Cheung",
      "Rebecca Pan",
      "Kelly Lai Chen",
    ],
    rating: 8.1,
    votes: 170000,
    language: "Cantonese, Shanghainese, French",
    country: "Hong Kong, France",
    plot: "Two neighbors form a strong bond after both suspect their spouses of infidelity. However, they agree to keep their relationship platonic to avoid falling into the same patterns.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiCL1dmT4swBQuIfzthOZh_ne2sFFzAfLoTyu8r3ZrU3WJ8RtjZcqfrns&s=10",
  },
  {
    id: "tt0181875",
    title: "Almost Famous",
    year: 2000,
    genre: ["Adventure", "Comedy", "Drama", "Music"],
    durationMinutes: 122,
    director: "Cameron Crowe",
    cast: [
      "Billy Crudup",
      "Patrick Fugit",
      "Kate Hudson",
      "Frances McDormand",
      "Jason Lee",
      "Philip Seymour Hoffman",
    ],
    rating: 7.9,
    votes: 310000,
    language: "English",
    country: "United States",
    plot: "A high-school boy in the early 1970s is given the chance to write a story for Rolling Stone magazine about an up-and-coming rock band as he accompanies them on their concert tour.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKT0sAK715hJLaIkBfoi6LTbNDv18JCqWKgg&s",
  },
  {
    id: "tt0876563",
    title: "Ponyo",
    year: 2008,
    genre: ["Animation", "Adventure", "Family", "Fantasy"],
    durationMinutes: 101,
    director: "Hayao Miyazaki",
    cast: [
      "Yuria Nara",
      "Hiroki Doi",
      "Tomoko Yamaguchi",
      "Kazushige Nagashima",
      "Yuki Amami",
      "George Tokoro",
    ],
    rating: 7.6,
    votes: 150000,
    language: "Japanese",
    country: "Japan",
    plot: "A goldfish named Ponyo escapes from the sea and is rescued by a five-year-old boy, Sosuke. As they grow close, Ponyo wishes to become human, but her transformation causes a dangerous imbalance in the natural world.",
    posterUrl:
      "https://i.pinimg.com/736x/4e/3d/80/4e3d805bb3c46870f79e6b9e4a345b5b.jpg",
  },
  {
    id: "tt0111771",
    title: "Why don't you play in hell?",
    originalTitle: "地獄でなぜ悪い",
    year: 2013,
    genre: ["Acción", "Comedia"],
    durationMinutes: 130,
    director: "Sion Sono",
    cast: [
      "Jun Kunimura",
      "Hiroki Hasegawa",
      "Shin’ichi Tsutsum",
      "Fumi Nikaido",
      "Gen Hoshino",
      "Tak Sakaguchi",
      "Tomochika",
      "Megumi Kagurazaka",
    ],
    rating: 7.8,
    votes: 2400000,
    language: "Japanese",
    country: "Japan",
    plot: "En Japón, cineastas gonzo idean un plan de tres puntos para salvar la carrera de una actriz, terminar con una guerra yakuza y hacer una exitosa película.",
    posterUrl:
      "https://images.mubicdn.net/images/artworks/451427/cache-451427-1645806327/images-original.png",
  },
  {
    id: "tt0111161",
    title: "The Shawshank Redemption",
    year: 1994,
    genre: ["Drama"],
    durationMinutes: 142,
    director: "Frank Darabont",
    cast: ["Tim Robbins", "Morgan Freeman", "Bob Gunton", "William Sadler"],
    rating: 9.3,
    votes: 2800000,
    language: "English",
    country: "USA",
    plot: "Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BNDE3ODcxYzMtY2YzZC00NmNlLWJiNDMtZDViZWM2MzIxZDYwXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_SX300.jpg",
  },
  {
    id: "tt0068646",
    title: "The Godfather",
    year: 1972,
    genre: ["Crime", "Drama"],
    durationMinutes: 175,
    director: "Francis Ford Coppola",
    cast: ["Marlon Brando", "Al Pacino", "James Caan", "Diane Keaton"],
    rating: 9.2,
    votes: 1900000,
    language: "English",
    country: "USA",
    plot: "The aging patriarch of an organized crime dynasty transfers control of his clandestine empire to his reluctant son.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BM2MyNjYxNmUtYTAwNi00MTYxLWJmNWYtYzZlODY3ZTk3OTFlXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0468569",
    title: "The Dark Knight",
    year: 2008,
    genre: ["Action", "Crime", "Drama"],
    durationMinutes: 152,
    director: "Christopher Nolan",
    cast: ["Christian Bale", "Heath Ledger", "Aaron Eckhart", "Michael Caine"],
    rating: 9.0,
    votes: 2700000,
    language: "English",
    country: "USA",
    plot: "When the menace known as the Joker wreaks havoc and chaos on the people of Gotham, Batman must accept one of the greatest psychological and physical tests.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMTMxNTMwODM0NF5BMl5BanBnXkFtZTcwODAyMTk2Mw@@._V1_SX300.jpg",
  },
  {
    id: "tt0071562",
    title: "The Godfather Part II",
    year: 1974,
    genre: ["Crime", "Drama"],
    durationMinutes: 202,
    director: "Francis Ford Coppola",
    cast: ["Al Pacino", "Robert De Niro", "Robert Duvall", "Diane Keaton"],
    rating: 9.0,
    votes: 1300000,
    language: "English",
    country: "USA",
    plot: "The early life and career of Vito Corleone in 1920s New York City is portrayed, while his son, Michael, expands and tightens his grip on the family crime syndicate.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMWMwMGQzZTItY2JlNC00OWZiLWIyMDctNDk2ZDQ2YjRjMWQ0XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0050083",
    title: "12 Angry Men",
    year: 1957,
    genre: ["Crime", "Drama"],
    durationMinutes: 96,
    director: "Sidney Lumet",
    cast: ["Henry Fonda", "Lee J. Cobb", "Martin Balsam", "John Fiedler"],
    rating: 9.0,
    votes: 820000,
    language: "English",
    country: "USA",
    plot: "The jury in a New York City murder trial is frustrated by a single member whose skeptical caution forces them to more carefully consider the evidence.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMWU4N2FjNzYtNTVkNC00NzQ0LTg0MjAtYTJlMjFhNGUxZDFmXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_SX300.jpg",
  },
  {
    id: "tt0108052",
    title: "Schindler's List",
    year: 1993,
    genre: ["Biography", "Drama", "History"],
    durationMinutes: 195,
    director: "Steven Spielberg",
    cast: ["Liam Neeson", "Ralph Fiennes", "Ben Kingsley", "Caroline Goodall"],
    rating: 9.0,
    votes: 1400000,
    language: "English",
    country: "USA",
    plot: "In German-occupied Poland during World War II, industrialist Oskar Schindler gradually becomes concerned for his Jewish workforce after witnessing their persecution by the Nazis.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BNDE4OTMxMTctNmRhYy00NWE2LTg3YzItYTk3M2UwOTU5Njg4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0167260",
    title: "The Lord of the Rings: The Return of the King",
    year: 2003,
    genre: ["Action", "Adventure", "Drama"],
    durationMinutes: 201,
    director: "Peter Jackson",
    cast: ["Elijah Wood", "Viggo Mortensen", "Ian McKellen", "Orlando Bloom"],
    rating: 9.0,
    votes: 1900000,
    language: "English",
    country: "New Zealand",
    plot: "Gandalf and Aragorn lead the World of Men against Sauron's army to draw his gaze from Frodo and Sam as they approach Mount Doom with the One Ring.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BNzA5ZDNlZWMtM2NhNS00NDJjLTk4NDItYTRmY2EwMWZlMTY3XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0110912",
    title: "Pulp Fiction",
    year: 1994,
    genre: ["Crime", "Drama"],
    durationMinutes: 154,
    director: "Quentin Tarantino",
    cast: ["John Travolta", "Uma Thurman", "Samuel L. Jackson", "Bruce Willis"],
    rating: 8.9,
    votes: 2100000,
    language: "English",
    country: "USA",
    plot: "The lives of two mob hitmen, a boxer, a gangster and his wife intertwine in four tales of violence and redemption.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BNGNhMDIzZTUtNTBlZi00MTRlLWFjM2ItYzViMjE3YzI5MjljXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0120737",
    title: "The Lord of the Rings: The Fellowship of the Ring",
    year: 2001,
    genre: ["Action", "Adventure", "Drama"],
    durationMinutes: 178,
    director: "Peter Jackson",
    cast: ["Elijah Wood", "Ian McKellen", "Orlando Bloom", "Sean Bean"],
    rating: 8.8,
    votes: 1900000,
    language: "English",
    country: "New Zealand",
    plot: "A meek Hobbit from the Shire and eight companions set out on a journey to destroy the powerful One Ring and save Middle-earth from the Dark Lord Sauron.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BN2EyZjM3NzUtNWUzMi00MTgxLWI0NTctMzY4M2VlOTdjZWRiXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_SX300.jpg",
  },
  {
    id: "tt0060196",
    title: "The Good, the Bad and the Ugly",
    originalTitle: "Il buono, il brutto, il cattivo",
    year: 1966,
    genre: ["Western"],
    durationMinutes: 178,
    director: "Sergio Leone",
    cast: ["Clint Eastwood", "Eli Wallach", "Lee Van Cleef", "Aldo Giuffrè"],
    rating: 8.8,
    votes: 790000,
    language: "Italian",
    country: "Italy",
    plot: "A bounty hunting scam joins two men in an uneasy alliance against a third in a race to find a fortune in gold buried in a remote cemetery.",
    posterUrl:
      "https://m.media-amazon.com/images/I/51cwIVtrVHL._UF894,1000_QL80_.jpg",
  },
  {
    id: "tt0137523",
    title: "Fight Club",
    year: 1999,
    genre: ["Drama"],
    durationMinutes: 139,
    director: "David Fincher",
    cast: ["Brad Pitt", "Edward Norton", "Meat Loaf", "Jared Leto"],
    rating: 8.8,
    votes: 2200000,
    language: "English",
    country: "USA",
    plot: "An insomniac office worker and a devil-may-care soap maker form an underground fight club that evolves into much more.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMmEzNTkxYjQtZTc0MC00YTVjLTg5ZTEtZWMwOWVlYzY0NWIwXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0109830",
    title: "Forrest Gump",
    year: 1994,
    genre: ["Drama", "Romance"],
    durationMinutes: 142,
    director: "Robert Zemeckis",
    cast: ["Tom Hanks", "Robin Wright", "Gary Sinise", "Sally Field"],
    rating: 8.8,
    votes: 2100000,
    language: "English",
    country: "USA",
    plot: "The presidencies of Kennedy and Johnson, the Vietnam War, and other historical events unfold from the perspective of an Alabama man with an IQ of 75.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BNWIwODRlZTUtY2U3ZS00Yzg1LWJhNzYtMmZiYmEyNmU1NjMzXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_SX300.jpg",
  },
  {
    id: "tt0167261",
    title: "The Lord of the Rings: The Two Towers",
    year: 2002,
    genre: ["Action", "Adventure", "Drama"],
    durationMinutes: 179,
    director: "Peter Jackson",
    cast: ["Elijah Wood", "Ian McKellen", "Viggo Mortensen", "Orlando Bloom"],
    rating: 8.8,
    votes: 1700000,
    language: "English",
    country: "New Zealand",
    plot: "While Frodo and Sam edge closer to Mordor with the help of the shifty Gollum, the divided fellowship makes a stand against Sauron's new ally, Saruman, and his hordes of Isengard.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BZGMxZTdjZmYtMmE2Ni00ZTdkLWI5NTgtNjlmMjBiNzU2MmI5XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0080684",
    title: "Star Wars: Episode V - The Empire Strikes Back",
    year: 1980,
    genre: ["Action", "Adventure", "Fantasy"],
    durationMinutes: 124,
    director: "Irvin Kershner",
    cast: [
      "Mark Hamill",
      "Harrison Ford",
      "Carrie Fisher",
      "Billy Dee Williams",
    ],
    rating: 8.7,
    votes: 1300000,
    language: "English",
    country: "USA",
    plot: "After the Rebels are brutally overpowered by the Empire on the ice planet Hoth, Luke Skywalker begins Jedi training with Yoda.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BYmU1NDRjNDgtMzhiMi00NjZmLTg5NGItZDNiZjU5NTU4OTE0XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0073486",
    title: "One Flew Over the Cuckoo's Nest",
    year: 1975,
    genre: ["Drama"],
    durationMinutes: 133,
    director: "Miloš Forman",
    cast: [
      "Jack Nicholson",
      "Louise Fletcher",
      "Michael Berryman",
      "Danny DeVito",
    ],
    rating: 8.7,
    votes: 1000000,
    language: "English",
    country: "USA",
    plot: "In the Fall of 1963, a Korean War veteran and criminal pleads insanity and is admitted to a mental institution, where he rallies up the scared patients against the tyrannical nurse.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BZjA0OWVhOTAtYWQxNi00YzNhLWI4ZjYtNjFjZTEyYjJlNDVlL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_SX300.jpg",
  },
  {
    id: "tt0099685",
    title: "Goodfellas",
    year: 1990,
    genre: ["Biography", "Crime", "Drama"],
    durationMinutes: 145,
    director: "Martin Scorsese",
    cast: ["Robert De Niro", "Ray Liotta", "Joe Pesci", "Lorraine Bracco"],
    rating: 8.7,
    votes: 1200000,
    language: "English",
    country: "USA",
    plot: "The story of Henry Hill and his life in the mafia, covering his relationship with his wife Karen and his mob partners Jimmy Conway and Tommy DeVito.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BY2NkZjEzMDgtN2RjYy00YzM1LWI4ZmQtMjIwYjFjNmI3ZGEwXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_SX300.jpg",
  },
  {
    id: "tt0047478",
    title: "Seven Samurai",
    year: 1954,
    genre: ["Action", "Drama"],
    durationMinutes: 207,
    director: "Akira Kurosawa",
    cast: [
      "Toshirō Mifune",
      "Takashi Shimura",
      "Keiko Tsushima",
      "Yukiko Shimazaki",
    ],
    rating: 8.6,
    votes: 360000,
    language: "Japanese",
    country: "Japan",
    plot: "A poor village under attack by bandits recruits seven unemployed samurai to help them defend themselves.",
    posterUrl: "https://m.media-amazon.com/images/I/91OOTyd4ToL.jpg",
  },
  {
    id: "tt0038650",
    title: "It's a Wonderful Life",
    year: 1946,
    genre: ["Drama", "Family", "Fantasy"],
    durationMinutes: 130,
    director: "Frank Capra",
    cast: [
      "James Stewart",
      "Donna Reed",
      "Lionel Barrymore",
      "Thomas Mitchell",
    ],
    rating: 8.6,
    votes: 480000,
    language: "English",
    country: "USA",
    plot: "An angel is sent from Heaven to help a desperately frustrated businessman by showing him what life would have been like if he had never existed.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BZjc4NDZhZWMtNGEzYS00ZWU2LThlM2ItNTA0YzQ0OTExMTE2XkEyXkFqcGdeQXVyNjUwMzI2NzU@._V1_SX300.jpg",
  },
  {
    id: "tt0076759",
    title: "Star Wars: Episode IV - A New Hope",
    year: 1977,
    genre: ["Action", "Adventure", "Fantasy"],
    durationMinutes: 121,
    director: "George Lucas",
    cast: ["Mark Hamill", "Harrison Ford", "Carrie Fisher", "Alec Guinness"],
    rating: 8.6,
    votes: 1400000,
    language: "English",
    country: "USA",
    plot: "Luke Skywalker joins forces with a Jedi Knight, a cocky pilot, a Wookiee and two droids to save the galaxy from the Empire's world-destroying battle station.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BOTA5NjhiOTAtZWM0ZC00MWNhLThiMzEtZDFkOTk2OTU1ZDJkXkEyXkFqcGdeQXVyMTA4NDI1NTQx._V1_SX300.jpg",
  },
  {
    id: "tt0102926",
    title: "The Silence of the Lambs",
    year: 1991,
    genre: ["Crime", "Drama", "Thriller"],
    durationMinutes: 118,
    director: "Jonathan Demme",
    cast: [
      "Jodie Foster",
      "Anthony Hopkins",
      "Lawrence A. Bonney",
      "Kasi Lemmons",
    ],
    rating: 8.6,
    votes: 1500000,
    language: "English",
    country: "USA",
    plot: "A young FBI cadet must receive the help of an incarcerated and manipulative cannibal killer to help catch another serial killer.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BNjNhZTk0ZmEtNjJhMi00YzFlLWE1MmEtYzM1M2ZmMGMwMTU4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0114369",
    title: "Se7en",
    year: 1995,
    genre: ["Crime", "Drama", "Mystery"],
    durationMinutes: 127,
    director: "David Fincher",
    cast: [
      "Morgan Freeman",
      "Brad Pitt",
      "Kevin Spacey",
      "Andrew Kevin Walker",
    ],
    rating: 8.6,
    votes: 1700000,
    language: "English",
    country: "USA",
    plot: "Two detectives, a rookie and a veteran, hunt a serial killer who uses the seven deadly sins as his motives.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BOTUwODM5MTctZjczMi00OTk4LTg3NWUtNmVhMTAzNTNjYjcyXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0245429",
    title: "Spirited Away",
    originalTitle: "千と千尋の神隠し ",
    year: 2001,
    genre: ["Animation", "Adventure", "Family"],
    durationMinutes: 125,
    director: "Hayao Miyazaki",
    cast: ["Daveigh Chase", "Suzanne Pleshette", "Miyu Irino", "Rumi Hiiragi"],
    rating: 8.6,
    votes: 810000,
    language: "Japanese",
    country: "Japan",
    plot: "During her family's move to the suburbs, a sullen 10-year-old girl wanders into a world ruled by gods, witches, and spirits.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMjlmZmI5MDctNDE2YS00YWE0LWE5ZWItZDBhYWQ0NTcxNWRhXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_SX300.jpg",
  },
  {
    id: "tt0120815",
    title: "Saving Private Ryan",
    year: 1998,
    genre: ["Drama", "War"],
    durationMinutes: 169,
    director: "Steven Spielberg",
    cast: ["Tom Hanks", "Matt Damon", "Tom Sizemore", "Edward Burns"],
    rating: 8.6,
    votes: 1400000,
    language: "English",
    country: "USA",
    plot: "Following the Normandy Landings, a group of U.S. soldiers go behind enemy lines to retrieve a paratrooper whose brothers have been killed in action.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BZjhkMDM4MWItZTVjOC00ZDRhLThmYTAtM2I5NzBmNmNlMzI1XkEyXkFqcGdeQXVyNDYyMDk5MTU@._V1_SX300.jpg",
  },
  {
    id: "tt0114814",
    title: "The Usual Suspects",
    year: 1995,
    genre: ["Crime", "Drama", "Mystery"],
    durationMinutes: 106,
    director: "Bryan Singer",
    cast: [
      "Kevin Spacey",
      "Gabriel Byrne",
      "Chazz Palminteri",
      "Stephen Baldwin",
    ],
    rating: 8.5,
    votes: 1100000,
    language: "English",
    country: "USA",
    plot: "A sole survivor tells of the twisty events leading up to a horrific gun battle on a boat, which began when five criminals met at a seemingly random police lineup.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BYTViNjMyNmUtNDFkNC00ZDRlLThmMDUtZDU2YWE4NGI2ZjVmXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0120689",
    title: "The Green Mile",
    year: 1999,
    genre: ["Crime", "Drama", "Fantasy"],
    durationMinutes: 189,
    director: "Frank Darabont",
    cast: ["Tom Hanks", "Michael Clarke Duncan", "David Morse", "Bonnie Hunt"],
    rating: 8.6,
    votes: 1300000,
    language: "English",
    country: "USA",
    plot: "The lives of guards on Death Row are affected by one of their charges: a black man accused of child murder and rape, yet who has a mysterious gift.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMTUxMzQyNjA5MF5BMl5BanBnXkFtZTYwOTU2NTY3._V1_SX300.jpg",
  },
  {
    id: "tt0317248",
    title: "City of God",
    originalTitle: "Cidade de Deus",
    year: 2002,
    genre: ["Crime", "Drama"],
    durationMinutes: 130,
    director: "Fernando Meirelles",
    cast: [
      "Alexandre Rodrigues",
      "Leandro Firmino",
      "Matheus Nachtergaele",
      "Phellipe Haagensen",
    ],
    rating: 8.6,
    votes: 780000,
    language: "Portuguese",
    country: "Brazil",
    plot: "In the slums of Rio, two kids' paths diverge as one struggles to become a photographer and the other a kingpin.",
    posterUrl: "https://m.media-amazon.com/images/I/71HokI188fL.jpg",
  },
  {
    id: "tt0253474",
    title: "The Pianist",
    year: 2002,
    genre: ["Biography", "Drama", "Music"],
    durationMinutes: 150,
    director: "Roman Polanski",
    cast: ["Adrien Brody", "Thomas Kretschmann", "Frank Finlay", "Emilia Fox"],
    rating: 8.5,
    votes: 860000,
    language: "English",
    country: "France",
    plot: "A Polish Jewish musician struggles to survive the destruction of the Warsaw ghetto of World War II.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BOWRiZDIxZjktMTA1NC00MDQ2LWEzMjUtMTliZmY3NjQ3ODJiXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0110413",
    title: "Léon: The Professional",
    year: 1994,
    genre: ["Action", "Crime", "Drama"],
    durationMinutes: 110,
    director: "Luc Besson",
    cast: ["Jean Reno", "Gary Oldman", "Natalie Portman", "Danny Aiello"],
    rating: 8.5,
    votes: 1200000,
    language: "English",
    country: "France",
    plot: "12-year-old Mathilda is reluctantly taken in by Léon, a professional assassin, after her family is murdered.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BODllNWE0MmEtYjUwZi00ZjY3LThmNmQtZjZlMjI2YTZjYmQ0XkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_SX300.jpg",
  },
  {
    id: "tt0172495",
    title: "Gladiator",
    year: 2000,
    genre: ["Action", "Adventure", "Drama"],
    durationMinutes: 155,
    director: "Ridley Scott",
    cast: ["Russell Crowe", "Joaquin Phoenix", "Connie Nielsen", "Oliver Reed"],
    rating: 8.5,
    votes: 1600000,
    language: "English",
    country: "USA",
    plot: "A former Roman General sets out to exact vengeance against the corrupt emperor who murdered his family and sent him into slavery.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMDliMmNhNDEtODUyOS00MjNlLTgxODEtN2U3NzIxMGVkZTA1L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
  },
  {
    id: "tt0482571",
    title: "The Prestige",
    year: 2006,
    genre: ["Drama", "Mystery", "Sci-Fi"],
    durationMinutes: 130,
    director: "Christopher Nolan",
    cast: [
      "Christian Bale",
      "Hugh Jackman",
      "Scarlett Johansson",
      "Michael Caine",
    ],
    rating: 8.5,
    votes: 1400000,
    language: "English",
    country: "USA",
    plot: "After a tragic accident, two stage magicians engage in a battle to create the ultimate illusion while sacrificing everything they have to outwit each other.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BMjA4NDI0MTIxNF5BMl5BanBnXkFtZTYwNTM0MzY2._V1_SX300.jpg",
  },
  {
    id: "tt0457591",
    title: "Nacho Libre",
    year: 2006,
    genre: ["Comedy", "Family", "Sport"],
    durationMinutes: 92,
    director: "Jared Hess",
    cast: ["Jack Black", "Ana de la Reguera", "Héctor Jiménez", "Darius Rose"],
    rating: 5.8,
    votes: 105000,
    language: "English",
    country: "USA",
    plot: "Berated all his life by those around him, a monk follows his dream and dons a mask to moonlight as a luchador (Mexican wrestler).",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkX3mCE7PXKFsdJwWG4ZXubvnQ3wbWan7uqg&s",
  },
  {
    id: "tt1630092",
    title: "Avatar: The Way of Water",
    year: 2022,
    genre: ["Action", "Adventure", "Fantasy", "Sci-Fi"],
    durationMinutes: 192,
    director: "James Cameron",
    cast: [
      "Sam Worthington",
      "Zoe Saldana",
      "Sigourney Weaver",
      "Kate Winslet",
    ],
    rating: 7.6,
    votes: 450000,
    language: "English",
    country: "USA",
    plot: "Jake Sully lives with his newfound family formed on the extrasolar moon Pandora. Once a familiar threat returns to finish what was previously started, Jake must work with Neytiri and the army of the Na'vi race to protect their home.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdOPfGFXxSxuyiq4rYpdWZPWlzN1mRq_tdgg&s",
  },
  {
    id: "tt5580393",
    title: "The Shape of Water",
    year: 2017,
    genre: ["Drama", "Fantasy", "Romance"],
    durationMinutes: 123,
    director: "Guillermo del Toro",
    cast: ["Sally Hawkins", "Octavia Spencer", "Michael Shannon", "Doug Jones"],
    rating: 7.3,
    votes: 440000,
    language: "English",
    country: "USA",
    plot: "At a top secret research facility in the 1960s, a lonely janitor forms a unique relationship with an amphibious creature that is being held in captivity.",
    posterUrl:
      "https://m.media-amazon.com/images/M/MV5BOGFlMTM2MTgtZDdlMy00ZDZlLWFjOTUtZDMzMGEwNmNiMWY0XkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg",
  },
  {
    id: "tt3967894",
    title: "Okja",
    originalTitle: "옥자",
    year: 2017,
    genre: ["Action", "Adventure", "Drama", "Sci-Fi"],
    durationMinutes: 120,
    director: "Bong Joon Ho",
    cast: ["Tilda Swinton", "Paul Dano", "An Seo Hyun", "Jake Gyllenhaal"],
    rating: 7.3,
    votes: 150000,
    language: "Korean",
    country: "South Korea",
    plot: "A young girl risks everything to prevent a powerful, multinational company from kidnapping her best friend - a fascinating beast named Okja.",
    posterUrl:
      "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcThMmQN_yXAf5wfRINPKMJVdsBlbccvKwgaEHn2mc0Gc7EPZx3rUF6m4M0fxa0lnC4rWZwSEQ",
  },
  {
    id: "tt1034495",
    title: "Suspiria",
    year: 2018,
    genre: ["Drama", "Fantasy", "Horror"],
    durationMinutes: 152,
    director: "Luca Guadagnino",
    cast: ["Dakota Johnson", "Tilda Swinton", "Mia Goth", "Chloë Grace Moretz"],
    rating: 6.7,
    votes: 95000,
    language: "English",
    country: "Italy",
    plot: "A darkness swirls at the center of a world-renowned dance company, one that will engulf the artistic director, an ambitious young dancer, and a grieving psychotherapist. Some will succumb to the nightmare. Others will finally wake up.",
    posterUrl: "https://m.media-amazon.com/images/I/61Emapd1JJL.jpg",
  },
  {
    id: "tt3783996",
    title: "La La Land",
    year: 2016,
    genre: ["Comedy", "Drama", "Music", "Romance"],
    durationMinutes: 128,
    director: "Damien Chazelle",
    cast: ["Ryan Gosling", "Emma Stone", "John Legend", "Rosemarie DeWitt"],
    rating: 8.0,
    votes: 600000,
    language: "English",
    country: "USA",
    plot: "While navigating their careers in Los Angeles, a pianist and an actress fall in love while attempting to reconcile their aspirations for the future.",
    posterUrl:
      "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQvoe8xaMfWFXUOD8UoFXNYWtCacTXKFNxlNps-Va7srK8EciqRIvoSfgh1cHdreXgzfmGT4_rIvtob3-Al2iblCuM12fGuUsgAMVSi7A",
  },
  {
    id: "tt15721088",
    title: "The Other Zoey",
    year: 2023,
    genre: ["Comedy", "Romance"],
    durationMinutes: 91,
    director: "Sara Zandieh",
    cast: [
      "Josephine Langford",
      "Drew Starkey",
      "Archie Renaux",
      "Andie MacDowell",
    ],
    rating: 5.9,
    votes: 12000,
    language: "English",
    country: "USA",
    plot: "Zoey Miller, a super smart computer major uninterested in romantic love, has her life turned upside down when Zack, the school's soccer star, gets amnesia and mistakes Zoey for his girlfriend.",
    posterUrl:
      "https://a.ltrbxd.com/resized/film-poster/8/1/9/4/2/9/819429-the-other-zoey-0-460-0-690-crop.jpg?v=709a167e69",
  },
  {
    id: "tt1853789",
    title: "Django Unchained",
    year: 2012,
    genre: ["Drama", "Western"],
    durationMinutes: 165,
    director: "Quentin Tarantino",
    cast: [
      "Jamie Foxx",
      "Christoph Waltz",
      "Leonardo DiCaprio",
      "Samuel L. Jackson",
    ],
    rating: 8.5,
    votes: 1600000,
    language: "English",
    country: "USA",
    plot: "With the help of a German bounty-hunter, a freed slave sets out to rescue his wife from a brutal plantation owner in Mississippi.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCHbDiz4-yZUlPohCQngxXcI_fXfVeWeJdWw&s",
  },
  {
    id: "tt0377092",
    title: "Mean Girls",
    year: 2004,
    genre: ["Comedy"],
    durationMinutes: 97,
    director: "Mark Waters",
    cast: ["Lindsay Lohan", "Rachel McAdams", "Tina Fey", "Amy Poehler"],
    rating: 7.1,
    votes: 400000,
    language: "English",
    country: "USA",
    plot: "Cady Heron is a hit with The Plastics, the A-list girl clique at her new school, until she makes the mistake of falling for Aaron Samuels, the ex-boyfriend of alpha Plastic Regina George.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3JBzmhPa3xx8ixOGd1stD_V2Kq2BWoHbhg1kfqplhQtthtePiLbViqvNBtnKNkOpH6LWlYA",
  },
  {
    id: "tt0078793",
    title: "Alien",
    year: 1979,
    genre: ["Horror", "Sci-Fi"],
    durationMinutes: 117,
    director: "Ridley Scott",
    cast: [
      "Sigourney Weaver",
      "Tom Skerritt",
      "John Hurt",
      "Veronica Cartwright",
    ],
    rating: 8.5,
    votes: 900000,
    language: "English",
    country: "USA",
    plot: "The crew of a commercial spacecraft encounter a deadly lifeform after investigating an unknown transmission.",
    posterUrl:
      "https://lumiere-a.akamaihd.net/v1/images/romulus_payoff_poster_las_bc34960b.jpeg?region=0,0,770,1100",
  },
  {
    id: "tt0206694",
    title: "Children of Men",
    year: 2006,
    genre: ["Action", "Drama", "Sci-Fi", "Thriller"],
    durationMinutes: 109,
    director: "Alfonso Cuarón",
    cast: ["Clive Owen", "Julianne Moore", "Michael Caine", "Chiwetel Ejiofor"],
    rating: 7.9,
    votes: 520000,
    language: "English",
    country: "UK",
    plot: "In 2027, in a chaotic world in which women have somehow become infertile, a former activist agrees to help transport a miraculously pregnant woman to a sanctuary at sea.",
    posterUrl:
      "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1388271989i/41913.jpg",
  },
  {
    id: "tt6751695",
    title: "Parasite",
    originalTitle: "기생충",
    year: 2019,
    genre: ["Drama", "Thriller"],
    durationMinutes: 132,
    director: "Bong Joon Ho",
    cast: ["Song Kang-ho", "Lee Sun-kyun", "Cho Yeo-jeong", "Choi Woo-shik"],
    rating: 8.5,
    votes: 900000,
    language: "Korean",
    country: "South Korea",
    plot: "Greed and class discrimination threaten the newly formed symbiotic relationship between the wealthy Park family and the destitute Kim clan.",
    posterUrl:
      "https://es.web.img3.acsta.net/newsv7/20/01/18/10/49/14611770.jpg",
  },
  {
    id: "tt0133093",
    title: "The Matrix",
    year: 1999,
    genre: ["Action", "Sci-Fi"],
    durationMinutes: 136,
    director: "Lana Wachowski, Lilly Wachowski",
    cast: [
      "Keanu Reeves",
      "Laurence Fishburne",
      "Carrie-Anne Moss",
      "Hugo Weaving",
    ],
    rating: 8.7,
    votes: 2000000,
    language: "English",
    country: "USA",
    plot: "A computer hacker learns about the true nature of reality and his role in the war against its controllers.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTX1s1SiveaHQHn1x1BdHKceVrflm-l35aSmP9Vzcl40w&s=10",
  },

  {
    id: "tt0111163",
    title: "How to dissapear",
    year: 1994,
    genre: ["Drama"],
    durationMinutes: 142,
    director: "Frank Darabont",
    cast: ["Tim Robbins", "Morgan Freeman", "Bob Gunton", "William Sadler"],
    rating: 9.3,
    votes: 2800000,
    language: "English",
    country: "USA",
    plot: "Two imprisoned men bond over years, finding solace and eventual redemption through acts of common decency.",
    posterUrl:
      "https://upload.wikimedia.org/wikipedia/en/d/df/Arrival%2C_Movie_Poster.jpg",
  },
  {
    id: "tt1851428",
    title: "Alice in the wonderland",
    year: 2012,
    genre: ["Drama", "Western"],
    durationMinutes: 165,
    director: "Tim Burton",
    cast: [
      "Jhonny Deep",
      "Christoph Waltz",
      "Leonardo DiCaprio",
      "Kerry Washington",
    ],
    rating: 8.4,
    votes: 1600000,
    language: "English",
    country: "USA",
    plot: "With the help of a German bounty hunter, a freed slave sets out to rescue his wife from a brutal plantation owner.",
    posterUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxq9V8h85pD0vmAR6dR_t7h9QTxlHWu-6XyUSZVMwRdw&s=10",
  },
];

export const DataBaseLikes = [
  {
    id: 40001,
    idMubiLiked: "tt6751695",
    idUserAsociated: "usr_002",
  },
  {
    id: 40002,
    idMubiLiked: "tt0206694",
    idUserAsociated: "usr_001",
  },
  {
    id: 40003,
    idMubiLiked: "tt1853789",
    idUserAsociated: "usr_001",
  },
  {
    id: 40004,
    idMubiLiked: "tt3783996",
    idUserAsociated: "usr_001",
  },
  {
    id: 40005,
    idMubiLiked: "tt0245429",
    idUserAsociated: "usr_001",
  },
  { id: 40006, idMubiLiked: "tt5580393", idUserAsociated: "usr_001" },
  { id: 40007, idMubiLiked: "tt0876563", idUserAsociated: "usr_001" },
];

/*En este ejemplo voy a guardar una reseña de parásitos  */
export const DataBaseReviews = [
  {
    id: 50001,
    idUserList: "usr_001",
    idMubiLis: "tt6751695",
    starRanking: 5,
    txtReview:
      " how do you think the teachers at abbott elementary would have handled this?",
    likes: 14,
    date: "4 Agosto",
    spoilers: true,
  },
  {
    id: 50002,
    idUserList: "usr_001",
    idMubiLis: "tt1630092",
    starRanking: 1,
    txtReview:
      " Can imagine another six, ten films about the same thing, there`s nothing groundbreacking about avatar movies, the first was a good one, but, Spilber need to stop this. I gave it 1 star cause i cannot rank with less",
    likes: 4,
    date: "14 Septiembre",
    spoilers: false,
  },
  {
    id: 50003,
    idUserList: "usr_001",
    idMubiLis: "tt3783996",
    starRanking: 4,
    txtReview: "I dont know what the hell i'm doing with my life.",
    likes: 0,
    date: "21 de Junio",
    spoilers: false,
  },
  {
    id: 50004,
    idUserList: "usr_001",
    idMubiLis: "tt1034495",
    starRanking: 4,
    txtReview:
      "Pick a horror clasic film, a good director and the best of Tom York in the soundtrack. Obvious a masterpiece",
    likes: 17,
    date: "29 de Junio",
    spoilers: false,
  },
];

export const ownerList = [
  {
    _id: 10001,
    idUser: "usr_001",
    title: "Selfless love",
    audience: "public",
    createdAt: "2025-10-05T19:00:00Z",

    mubis: [
      "tt0111771",
      "tt0047478",
      "tt0245429",
      "tt0317248",
      "tt6751695",
      "tt0078793",
    ],

    description:
      "Esta lista la hice de las películas que veía cuando te perdí, aunque en realidad nunca te tuve, me he sentado a reflexionar cuando extraño algo que nunca se dio, no paro de llorar en mis sueños, despiero en medio de las lagrimas de aquel sueño que parece sacado de una realidad alterna, al que me desisto a creer, pero al final de la noche despierto sabiendo que nada es real, que la unica verdad absoluta es que pedí a la vida algo que me dolía, que realmente nunca debí irme, nunca debimos irnos, ahora solo queda en irnos",
  },
  {
    _id: 10002,
    idUser: "usr_001",
    title: "Moments of Courage",
    audience: "friends",
    createdAt: "2024-08-01T19:00:00Z",
    mubis: ["tt0482571", "tt0457591", "tt0120737", "tt0137523"],

    description:
      "Esta lista la armé pensando en el valor de ser valiente: son historias que me han inspirado a seguir adelante en momentos de duda.",
  },
  {
    _id: 10003,
    idUser: "usr_001",
    title: "Perro Valiente : 2",
    audience: "friends",
    createdAt: "2024-08-01T19:00:00Z",
    mubis: ["tt1630092", "tt0110413", "tt0206694", "tt0167260"],

    description:
      "Esta es una réplica de momentos de corage, pero con menos valores",
  },
  {
    _id: 10004,
    idUser: "usr_002",
    title: "One Battle After Another",
    audience: "friends",
    createdAt: "2024-08-01T19:00:00Z",
    mubis: ["tt0080684", "tt0076759"],
    description:
      "Esto debería aparecer como una opción de nota de la lista que hice",
  },
  {
    _id: 10005,
    idUser: "usr_001",
    title: "In the mood for...",
    audience: "public",
    createdAt: "2024-08-01T19:00:00Z",
    mubis: [
      "tt0118694",
      "tt0133093",
      "tt0468569",
      "tt0109830",
      "tt0111161",
      "tt1851428",
      "tt0111163",
    ],
    description: "Si en algún momento estoy in the mood for...",
  },
];

/*En esta review, se compara si coincide el id de película si está en los id de
películas de la categoría LIKES por usuario para mostrar un icono ♥️, devuelve un true ✅ o false ❌*/

/*ANSWER: Whose review is this ¯\_(ツ)_/¯? */
export const totalReviews = [
  {
    id: 70001,
    watched: "24 Septiembre 2025",
    star_ranking: 1,
    date: undefined,
    spoilers: false,
    liked: false,
    txt_review: "The one where noah bumback attempts his best nilly wilder",
    total_likes: 0,
    id_mubi: ["tt0078793"] /*Alien */,
    id_user: "usr_001",
  },
  {
    id: 70002,
    watched: "30 Septiembre del 2025",
    star_ranking: 4,
    date: undefined,
    spoilers: true,
    liked: true,
    txt_review: "An underrated one",
    total_likes: 0,
    id_mubi: ["tt0109830"] /*Forest Gump*/,
    id_user: "usr_001",
  },
  {
    id: 70003,
    watched: "14 de enero del 2025",
    star_ranking: 5,
    date: undefined,
    spoilers: false,
    liked: true,
    txt_review:
      "how do you think the teachers at about elementary would have handled this?",
    total_likes: 14,
    id_mubi: ["tt6751695"],
    id_user: "usr_001",
  },
  {
    id: 70004,
    watched: "9 de septeimbre del 2020",
    star_ranking: 2,
    date: undefined,
    spoilers: false,
    liked: false,
    txt_review: "i don't know what the hell i'm doing with my life",
    total_likes: 4,
    id_mubi: ["tt3783996"],
    id_user: "usr_001",
  },
  {
    id: 70005,
    watched: "08 de Agosto del 2019",
    star_ranking: 1,
    date: undefined,
    spoilers: false,
    liked: false,
    txt_review:
      "Can imagine another six seven films about the same thing, there's nothing groundbraking about avatar movies",
    total_likes: 4,
    id_mubi: ["tt1630092"],
    id_user: "usr_001",
  },
  {
    id: 7006,
    watched: "02 Agosto del 2015",
    star_ranking: 2,
    date: false,
    spoilers: true,
    liked: false,
    txt_review:
      "pick a horror classic film, a good director and the best of Tom York in the soundtrack, obvious a masterpiece",
    total_likes: 3,
    id_mubi: ["tt1034495"],
    id_user: "usr_001",
  },
];
